import api from "./core";

const basePath = "api/core/Ability";

export default {
  isActive() {
    return api.get(`${basePath}/IsActive`);
  }
};
